import {
  Box,
  Flex,
  HStack,
  Img,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import ReactPaginate from "react-paginate";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";

/**
 * Bảng dùng chung cho 2 tab chấm công luồng mới (đăng ký + đơn đổi thiết bị/địa điểm).
 * Giao diện giống bảng "Yêu cầu đổi thiết bị".
 */
export default function CheckinRegistrationTable({
  headers,
  rows,
  renderCell,
  isLoaded,
  totalPages,
  currentPage,
  onPageChange,
  startEntry,
  endEntry,
  entries,
}) {
  return (
    <Box width={"100%"} height={"100%"}>
      <Skeleton isLoaded={isLoaded}>
        <TableContainer w={"100%"} maxH="calc(100vh - 300px)" overflowY="auto">
          <Table w={"100%"} variant="unstyled">
            <Thead
              position="sticky"
              top="0"
              zIndex="1"
              w={"100%"}
              h={"41px"}
              backgroundColor="#F9FAFD"
            >
              <Tr h={{ base: "41px" }}>
                <Td
                  p={"16px 16px 8px 16px"}
                  color={"#51607B"}
                  fontSize={{ base: "14px" }}
                  w={"2%"}
                >
                  <Box textAlign={"center"} fontWeight={"bold"}>
                    STT
                  </Box>
                </Td>
                {headers.map((h) => (
                  <Td
                    p={"16px 16px 8px 16px"}
                    key={h.key}
                    color={"#51607B"}
                    fontSize={{ base: "14px" }}
                    w={h.width || "auto"}
                  >
                    <Box textAlign={"center"} fontWeight={"bold"}>
                      {h.label}
                    </Box>
                  </Td>
                ))}
              </Tr>
            </Thead>
            <Tbody w={"100%"} h={"100%"}>
              {rows?.length > 0 ? (
                rows.map((row, rowIndex) => (
                  <Tr key={row.id || rowIndex} h={"72px"}>
                    <Td
                      p={"16px 16px 8px 16px"}
                      w={"2%"}
                      bg={
                        rowIndex % 2 === 0
                          ? "var(--color-main)"
                          : "var(--fill-avatar)"
                      }
                    >
                      {(currentPage - 1) * 25 + rowIndex + 1}
                    </Td>
                    {headers.map((h) => (
                      <Td
                        p={"16px 16px 8px 16px"}
                        key={h.key}
                        w={h.width || "auto"}
                        bg={
                          rowIndex % 2 === 0
                            ? "var(--color-main)"
                            : "var(--fill-avatar)"
                        }
                      >
                        <Box
                          fontSize={{ base: "14px" }}
                          lineHeight={"19.6px"}
                          textAlign={"start"}
                          fontWeight={500}
                          color={"var(--color-info-employee)"}
                          whiteSpace={"normal"}
                        >
                          {renderCell ? (
                            renderCell(h.key, row)
                          ) : (
                            <Text>{row[h.key]}</Text>
                          )}
                        </Box>
                      </Td>
                    ))}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={headers.length + 1}
                    textAlign="center"
                    padding={"40px 0"}
                  >
                    Không có dữ liệu
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </Skeleton>
      <Box mt={10} mr={5} mb={5} ml={5}>
        <Flex alignItems={"center"} justifyContent={"space-between"}>
          <Text>
            Showing {startEntry || 0} to {endEntry || 0} of {entries || 0}{" "}
            entries
          </Text>
          <HStack spacing={2} justify="flex-end">
            <ReactPaginate
              className="pagination-custom"
              pageCount={totalPages || 0}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              onPageChange={onPageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              breakClassName={"ellipsis"}
              breakLabel={"..."}
              previousLabel={
                <Img w={"16px"} minW={"16px"} h={"16px"} src={chevronLeft} />
              }
              nextLabel={
                <Img w={"16px"} minW={"16px"} h={"16px"} src={chevronRight} />
              }
              renderOnZeroPageCount={null}
              forcePage={(currentPage || 1) - 1}
            />
          </HStack>
        </Flex>
      </Box>
    </Box>
  );
}
